import { useEffect } from "react";

const SCALE = 100;

export default ({ changeZoom, zoom }) => {
  useEffect(() => {
    const wheel = (e) => {
      if (e.metaKey) {
        e.preventDefault();
        changeZoom(zoom + e.deltaY / SCALE);
      }
    };

    document.addEventListener("wheel", wheel, { passive: false });

    return () => {
      document.removeEventListener("wheel", wheel);
    };
  }, [zoom]);

  return {};
};
